const templateHTMLShadeFinderRecommendations = `
  <div class="tabs hide-scrollbars">
    <div class="tabs-container">
      <slot id="tab-slot" name="tab"></slot>
    </div>
  </div>
  <div class="tab-contents">
    <slot id="content-slot" name="content"></slot>
  </div>
`

class ShadeFinderRecommendations extends HHBaseElement {
  static observedAttributes = ['selected-index']
  #selectedIndex = 0

  constructor() {
    super(templateHTMLShadeFinderRecommendations)
    this.bind(this)
  }

  bind(element) {
    element.render = element.render.bind(element)
    element.attachEvents = element.attachEvents.bind(element)
    element.cacheDom = element.cacheDom.bind(element)
    element.onTabClick = element.onTabClick.bind(element)
    element.selectTabByIndex = element.selectTabByIndex.bind(element)
    element.onContentSlotChange = element.onContentSlotChange.bind(element)
    element.onTabSlotChange = element.onTabSlotChange.bind(element)
    element.onTabSlotKeyDown = element.onTabSlotKeyDown.bind(element)
  }

  connectedCallback() {
    this.cacheDom()
    this.attachEvents()
    this.dom.tabs[this.#selectedIndex]?.classList.add('selected')
    this.dom.contents[this.#selectedIndex]?.classList.add('selected')
    this.dom.tabs[this.#selectedIndex]?.setAttribute('aria-selected', true)
    this.dom.tabs[this.#selectedIndex]?.setAttribute('tabindex', 0)
  }

  cacheDom() {
    this.dom = {
      tabSlot: this._shadowRoot.querySelector('#tab-slot'),
      contentSlot: this._shadowRoot.querySelector('#content-slot'),
    }
    this.dom.tabs = this.dom.tabSlot.assignedElements()
    this.dom.contents = this.dom.contentSlot.assignedElements()
    this.$shadeFinder = this.closest('shade-finder')
  }

  attachEvents() {
    this.dom.tabSlot.addEventListener('click', this.onTabClick)
    this.dom.tabSlot.addEventListener('slotchange', this.onTabSlotChange)
    this.dom.tabSlot.addEventListener('keydown', this.onTabSlotKeyDown)
    this.dom.contentSlot.addEventListener(
      'slotchange',
      this.onContentSlotChange
    )
  }

  onTabSlotChange() {
    this.dom.tabs = this.dom.tabSlot.assignedElements()
  }

  onTabSlotKeyDown(e) {
    const target = e.target

    switch(e.key) {
      case 'ArrowLeft':
        if (target.slot === 'tab') {
          const tabIndex = this.dom.tabs.indexOf(target)
          if(tabIndex > 0) {
            this.selectTabByIndex(tabIndex - 1, true);
          } else {
            this.selectTabByIndex(this.dom.tabs.length - 1, true);
          }
        }
      break;

      case 'ArrowRight':
        if (target.slot === 'tab') {
          const tabIndex = this.dom.tabs.indexOf(target)
          if(tabIndex < this.dom.tabs.length - 1) {
            this.selectTabByIndex(tabIndex + 1, true);
          } else {
            this.selectTabByIndex(0, true);
          }
        }
      break;
    }
  }

  onContentSlotChange() {
    this.dom.contents = this.dom.contentSlot.assignedElements()
  }

  onTabClick(e) {
    const target = e.target
    if (target.slot === 'tab') {
      const tabIndex = this.dom.tabs.indexOf(target)
      this.selectTabByIndex(tabIndex)
    }
  }

  selectTabByIndex(index, focus = false) {
    const tab = this.dom.tabs[index]
    const content = this.dom.contents[index]
    if (!tab || !content) return
    this.dom.contents.forEach((p) => p.classList.remove('selected'))
    this.dom.tabs.forEach((p) => {
      p.classList.remove('selected')
      p.setAttribute('aria-selected', false)
      p.setAttribute('tabindex', -1)
    })
    content.classList.add('selected')
    tab.classList.add('selected')
    tab.setAttribute('aria-selected', true)
    tab.setAttribute('tabindex', 0)

    if ( focus ){
      tab.focus();
    }

    const swiperEl = content.querySelector('swiper-container')
    if (swiperEl) {
      setTimeout(() => {
        swiperEl.swiper.slideTo(0)

        if (this.$shadeFinder) {
          this.$shadeFinder._handleSlideSelectOrClick(swiperEl.swiper, 0)
        }
      }, 100)
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (name === 'selected-index') {
        this.selectedIndex = newValue
      }
    }
  }

  set selectedIndex(value) {
    this.#selectedIndex = value
  }

  get selectedIndex() {
    return this.#selectedIndex
  }
}

customElements.define(
  'shade-finder-recommendations',
  ShadeFinderRecommendations
)
